import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

const FONT = {
  emphasis: "'Soehne Kraftig', sans-serif",
} as const

const tokens = {
  dark: {
    successBg: 'status.success-bg',
    successText: 'status.success',
  },
  light: {
    successBg: 'light.status.resolved-bg',
    successText: 'light.status.resolved-text',
  },
} as const

export const successBannerStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  alignItems: 'center',
  bg: tokens[colorScheme].successBg,
  color: tokens[colorScheme].successText,
  display: 'flex',
  gap: '10px',
  px: '20px',
  py: '16px',
  w: 'full',
})

export const successBannerIconStyles: SystemStyleObject = {
  flexShrink: 0,
  h: '18px',
  w: '18px',
}

export const successBannerLabelStyles: SystemStyleObject = {
  color: 'inherit',
  fontFamily: FONT.emphasis,
  fontSize: '18px',
  fontWeight: '500',
  lineHeight: '24px',
  m: 0,
}
